import { Controller } from "@hotwired/stimulus"

// Подставляет цену выбранной услуги или товара в поле цены строки чека.
//
// Цена в чеке хранится своя (решение 26): справочник даёт отправную точку, а
// мастер может её изменить — ad hoc скидка. Поэтому подстановка происходит при
// смене выбора, а введённое вручную значение живёт до следующей смены.
export default class extends Controller {
  static targets = ["source", "price"]

  fill() {
    const option = this.sourceTarget.selectedOptions[0]
    const price = option && option.dataset.price

    if (price === undefined || price === null || price === "") return

    this.priceTarget.value = price
  }
}
